const SolanaBackpackIcon = ({ props }) => (
  <svg
    viewBox="49 0 48 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M91.8388 50.2642C94.2901 50.2642 95.5157 50.2642 96.277 51.0257C97.0386 51.787 97.0386 53.0127 97.0386 55.4639V58.9304C97.0386 63.8327 97.0386 66.2839 95.5157 67.807C93.9926 69.3299 91.5413 69.3299 86.6391 69.3299H59.7737C54.8714 69.3299 52.4202 69.3299 50.8972 67.807C49.3742 66.2839 49.3743 63.8327 49.3743 58.9304V55.4639C49.3743 53.0127 49.3743 51.787 50.1357 51.0257C50.8972 50.2642 52.1228 50.2642 54.574 50.2642H91.8388Z"
      fill="#E33E3F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.2064 10.1829C97.3855 10.1829 97.0386 26.3018 97.0386 34.015C97.0386 41.7282 97.0386 42.6812 97.0386 42.6812C97.0386 44.117 95.8745 45.2811 94.4387 45.2811H51.9742C50.5383 45.2811 49.3743 44.117 49.3743 42.6812C49.3743 42.6812 49.3743 41.7282 49.3743 34.015C49.3743 26.3018 49.0274 10.1829 73.2064 10.1829ZM73.2064 16.325C69.1381 16.325 65.8401 19.623 65.8401 23.6914C65.8402 27.7595 69.1382 31.0577 73.2064 31.0577C77.2748 31.0577 80.5727 27.7595 80.5727 23.6914C80.5727 19.623 77.2748 16.325 73.2064 16.325Z"
      fill="#E33E3F"
    />
    <path
      d="M73.1995 0.190674C78.4167 0.190674 82.9839 2.01423 84.1917 4.98397C84.3737 5.49636 84.4645 5.7526 84.3029 5.94285C84.141 6.13309 83.8282 6.07639 83.2022 5.96295C81.5847 5.66977 79.2946 5.46818 77.2784 5.40862C75.9919 5.33948 74.6348 5.30367 73.2068 5.30367C71.7795 5.30367 70.423 5.33955 69.1371 5.40862C67.1113 5.46815 64.8131 5.66971 63.1896 5.95301C62.5771 6.05991 62.2707 6.11327 62.1102 5.92359C61.9497 5.73386 62.0384 5.4823 62.216 4.97931C63.4141 2.01893 67.9837 0.19069 73.1995 0.190674Z"
      fill="#E33E3F"
    />
  </svg>
);

export default SolanaBackpackIcon;
